export default __webpack_public_path__ + "static/media/CONTENTDOC.15cb8cde.svg";